module.exports = __webpack_public_path__ + "img/folder-grid.c96f466d.svg";